<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="44"
    viewBox="0 0 46 44"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <path
                fill="#E1F5FE"
                d="M41.312 13.41c-.43-.482-1.02-.797-1.66-.886v-.001L29.64 11.14l-3.963-9.468C25.1.286 23.507-.368 22.121.211c-.66.275-1.186.8-1.462 1.461l-3.962 9.468-10.012 1.383c-1.492.207-2.533 1.585-2.325 3.077.089.64.403 1.23.887 1.66l7.543 6.727-1.55 10.555c-.168 1.072.324 2.14 1.249 2.709.91.582 2.083.56 2.971-.055l7.708-5.242 7.708 5.247c1.244.844 2.936.52 3.78-.724.384-.565.541-1.254.44-1.93l-1.55-10.559 7.544-6.727c1.124-1.002 1.224-2.726.222-3.85"
                transform="translate(-153 -581) translate(127 553) translate(24 24) translate(2.167 4.333)"
              />
              <path
                fill="#164194"
                d="M31.214 22.468c-.338.301-.501.752-.435 1.2l1.614 11.301-8.465-5.755c-.456-.31-1.055-.31-1.512 0l-8.515 5.72 1.656-11.272c.065-.445-.098-.894-.434-1.194L7.05 15.192l10.773-1.487c.472-.065.874-.374 1.058-.814l4.302-10.2c.005.006.009.013.011.02l4.258 10.175c.184.44.586.749 1.058.814l10.787 1.552-8.084 7.216zm10.098-9.057c-.43-.483-1.02-.798-1.66-.887v-.001L29.64 11.14l-3.963-9.468C25.1.286 23.507-.368 22.121.211c-.66.275-1.186.8-1.462 1.461l-3.962 9.468-10.012 1.383c-1.492.207-2.533 1.585-2.325 3.077.089.64.403 1.23.886 1.66l7.544 6.727-1.55 10.555c-.168 1.072.324 2.14 1.249 2.709.91.582 2.083.56 2.972-.055l7.707-5.242 7.708 5.247c1.244.844 2.936.52 3.78-.724.384-.565.541-1.254.44-1.93l-1.55-10.559 7.544-6.727c1.125-1.002 1.224-2.726.222-3.85z"
                transform="translate(-153 -581) translate(127 553) translate(24 24) translate(2.167 4.333)"
              />
              <path
                fill="#13A2E8"
                d="M36 7.536c-.361 0-.723-.127-1.013-.386-.627-.56-.682-1.522-.122-2.149l2.327-2.608c.56-.628 1.522-.682 2.149-.123.627.56.682 1.522.122 2.149l-2.328 2.609c-.3.337-.717.508-1.135.508"
                transform="translate(-153 -581) translate(127 553) translate(24 24) translate(2.167 4.333)"
              />
              <path
                fill="#13A2E8"
                d="M40.05 30.145c-.36 0-.722-.127-1.012-.386-.628-.56-.682-1.522-.123-2.149l2.328-2.609c.56-.627 1.522-.681 2.149-.122.627.56.681 1.522.122 2.149l-2.328 2.608c-.3.337-.717.509-1.136.509"
                transform="translate(-153 -581) translate(127 553) translate(24 24) translate(2.167 4.333) scale(1 -1) rotate(15 248.722 0)"
              />
              <path
                fill="#13A2E8"
                d="M8.028 7.15C7.4 6.59 7.346 5.628 7.906 5l2.327-2.608c.56-.628 1.522-.682 2.149-.123.627.56.682 1.522.122 2.149l-2.328 2.609c-.3.337-.717.508-1.135.508-.361 0-.723-.127-1.013-.386z"
                transform="translate(-153 -581) translate(127 553) translate(24 24) translate(2.167 4.333) matrix(-1 0 0 1 20.41 0)"
              />
              <path
                fill="#13A2E8"
                d="M3.147 29.759c-.627-.56-.682-1.522-.122-2.149l2.328-2.609c.56-.627 1.521-.681 2.148-.122.627.56.682 1.522.122 2.149l-2.327 2.608c-.3.337-.718.509-1.136.509-.36 0-.723-.127-1.013-.386z"
                transform="translate(-153 -581) translate(127 553) translate(24 24) translate(2.167 4.333) rotate(-165 5.324 27.319)"
              />
              <path
                fill="#13A2E8"
                d="M21.006 41.063c-.627-.56-.682-1.522-.123-2.149l2.328-2.608c.56-.627 1.522-.682 2.149-.123.627.56.682 1.522.122 2.149l-2.328 2.609c-.3.337-.717.508-1.136.508-.36 0-.722-.127-1.012-.386z"
                transform="translate(-153 -581) translate(127 553) translate(24 24) translate(2.167 4.333) rotate(138 23.183 38.623)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>